(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[776],{

/***/ 9859:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info",
      function () {
        return __webpack_require__(9237);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ info; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-seo@5.1.0_61390be992b634a688f7c2555547b55b/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(6351);
// EXTERNAL MODULE: ./src/ui/components/custom/Link/index.tsx
var Link = __webpack_require__(5879);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/styles/info/index.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n > h2 {\n  font-variant: small-caps;\n  font-stretch: 110%;\n  color: #f70;\n  margin: 2vh 2vw 0;\n\n  @media (max-width: 426px) {\n   margin: 2vh 4vw 0;\n  }\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n margin: 2vh 2vw 0;\n\n @media (max-width: 426px) {\n  margin: 2vh 4vw 0;\n }\n\n &:last-of-type {\n  margin-bottom: 2vh;\n\n  @media (max-width: 426px) {\n   margin-bottom: 3vh;\n  }\n }\n\n h3 {\n  font-variant: small-caps;\n  font-stretch: 110%;\n  color: #f70;\n  margin-bottom: 1vh;\n }\n\n p {\n  font-size: 0.9em;\n }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Styling = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2728669c-0"
})(_templateObject());
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-2728669c-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/pages/info/index.tsx




var description = 'Informa\xe7\xf5es-guia para autores, leitores e bibliotec\xe1rios.';
var title = 'Informa\xe7\xf5es';
var Info = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                description: description,
                openGraph: {
                    description: description,
                    title: title
                },
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styling, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Informa\xe7\xe3o para autores, leitores e bibliotec\xe1rios"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Para Leitores"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Convidamos os leitores a se cadastrarem no servi\xe7o de notifica\xe7\xe3o de publica\xe7\xe3o da revista. Clique em",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "/login",
                                        children: "Cadastro"
                                    }),
                                    " no menu superior da p\xe1gina. O cadastro permitir\xe1 ao leitor receber o sum\xe1rio via e-mail a cada edi\xe7\xe3o publicada."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Para Autores"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Deseja enviar contribui\xe7\xf5es \xe0 revista? Convidamos todos a conferirem as informa\xe7\xf5es dispon\xedveis na se\xe7\xe3o",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "/about",
                                        children: "Sobre"
                                    }),
                                    ", bem como as ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "/submissions",
                                        children: "diretrizes para autores"
                                    }),
                                    ". \xc9 necess\xe1rio que os autores se cadastrem no sistema antes de submeterem um artigo; caso j\xe1 tenha se cadastrado, basta acessar o sistema e iniciar o processo de submiss\xe3o."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "Para Bibliotec\xe1rios"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Convidamos as bibliotecas a listar revistas de Acesso Livre em seus cat\xe1logos de revistas eletr\xf4nicas. Este sistema de publica\xe7\xe3o \xe9 desenvolvido tamb\xe9m para ser hospedado e operado por bibliotecas, em apoio ao trabalho de publica\xe7\xe3o das revistas do seu corpo acad\xeamico. (saiba mais acessando a p\xe1gina oficial do",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "http://pkp.sfu.ca/ojs",
                                        children: "Open Journal Systems"
                                    }),
                                    ")"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var info = (Info);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [522,888,179], function() { return __webpack_exec__(9859); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);